module.exports = __webpack_public_path__ + "static/Raleway-VariableFont_wght-3b5635ac5d39c28200bf3993d90d09c7.ttf";